import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, Table, ModalHeader, ModalBody, FormGroup, Button, Modal, Label, Input, CardHeader, TabContent, TabPane } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import jsPDF from 'jspdf'
import { ReactBingmaps } from "react-bingmaps";
import * as html2canvas from 'html2canvas';
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./styles.css"

toast.configure();

const TripVehicle = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);



  const [trip_detail, settrip_detail] = useState([])
  const [completed_trip_detail, setcompleted_trip_detail] = useState([])
  const [trip_type, settrip_type] = useState([{
    trip_name: "Upcoming Trip",
  }, {
    trip_name: "Completed Trip",
  }])
  const [trip_status, settrip_status] = useState(0)

  const [tabtripdate, settabtripdate] = useState("")
  const [clientHeight, setclientHeight] = useState("")


  const [transport_distance, settransport_distance] = useState("")
  const [transport_charges, settransport_charges] = useState("")

  const [pick_up, setpick_up] = useState("")
  const [drop_off, setdrop_off] = useState("")

  const [activeTab1, setActiveTab1] = useState('1');
  const { t } = useTranslation();
  const [tabdelivery, setabdelivery] = useState("")
  const [rightSidebar, setRightSidebar] = useState(true);
  const openCustomizer = (type) => {
    settabtripdate("")
    setabdelivery("")
    setActiveTab1(type)
    setRightSidebar(!rightSidebar)
    if (rightSidebar) {
      document.querySelector(".customizer-contain").classList.add('open');

    }
  }
  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const LargeModaltoggle = () => {

    settransport_charges("")
    settransport_distance("")
    setpick_up("")
    setdrop_off("")

    setLarge(!Large);
  }




  useEffect(() => {
    if (localStorage.getItem('usertype') !== "Vehicle Owner") {
      window.history.back();
    }
    settrip_type([{
      trip_name: "Upcoming Trip",
    }, {
      trip_name: "Completed Trip",
    }])



    getTripDetail()
  }, [])






  async function getTripDetail() {

    settabtripdate("")



    setabdelivery("")
    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("vehicle_id", localStorage.getItem("userid"))
      .order('id', { ascending: false })

    if (trip_Details !== null && trip_Details.length > 0) {
      let upcomingarr = []
      let completedarr = []
      for (let i = 0; i < trip_Details.length; i++) {

        if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
          upcomingarr.push(trip_Details[i])
        } else {
          completedarr.push(trip_Details[i])
        }
      }




      settrip_detail(upcomingarr)
      setcompleted_trip_detail(completedarr)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.71)

      }, 1000)
    } else {
      if (error !== null) {
        // toast.error("No Buyer Details Found")
        settrip_detail([])
        setcompleted_trip_detail([])
      }
    }
  }







  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function convertdata(tripdate) {
    var date = new Date(tripdate)
    var day_date = date.getDate()
    var month = date.getMonth()
    var day = date.getDay()


    var newdate = dayNames[day] + "-" + day_date + "-" + monthNames[month]
    return newdate
  }

  async function gettripfilterdata(data, type) {

    if (type === "date") {




      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("trip_date", data)
        .eq("driverid", localStorage.getItem("userid"))

      if (trip_Details !== null && trip_Details.length > 0) {
        let upcomingarr = []
        let completedarr = []
        for (let i = 0; i < trip_Details.length; i++) {

          if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
            upcomingarr.push(trip_Details[i])
          } else {
            completedarr.push(trip_Details[i])
          }
        }


        settrip_detail(upcomingarr)
        setcompleted_trip_detail(completedarr)
      } else {
        if (error !== null) {
          // toast.error("No Buyer Details Found")
          settrip_detail([])
          setcompleted_trip_detail([])
        }
      }
    } else if (type === "delivery") {

      settabtripdate("")




      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("delivery_status", data)
        .eq("driverid", window.localStorage.getItem("userid"))

      if (trip_Details !== null && trip_Details.length > 0) {
        let upcomingarr = []
        let completedarr = []
        for (let i = 0; i < trip_Details.length; i++) {

          if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
            upcomingarr.push(trip_Details[i])
          } else {
            completedarr.push(trip_Details[i])
          }
        }


        settrip_detail(upcomingarr)
        setcompleted_trip_detail(completedarr)
      } else {
        // toast.error("No Buyer Details Found")
        if (error !== null) {
          settrip_detail([])
          setcompleted_trip_detail([])
        }
      }
    }



  }
  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  async function updatestatus(tripid, veh_invoice_id, status) {
    await supabase
      .from('vehicle_invoice_details')
      .delete()
      .eq('vehicle_invoice_id', veh_invoice_id)



    let vehicle_invoice_id = `vehicleinv${randomUsername()}`

    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .update({ vehicle_status: status, vehicle_invoice_id: vehicle_invoice_id })
      .eq("trip_id", tripid)
    if (trip_Details !== null && trip_Details.length > 0) {
      let { data: driver_details, driver_error } = await supabase
        .from('driver_details')
        .select('*')
        .eq("driver_id", trip_Details[0].driverid)
      if (driver_details !== null && driver_details.length > 0) {
        let { data: vehicledetail, vehicle_error } = await supabase
          .from('vehicle_details')
          .select('*')
          .eq("vehicle_id", trip_Details[0].vehicle_id)
        if (vehicledetail !== null && vehicledetail.length > 0) {
          let { data: buyer_details, buyer_error } = await supabase
            .from('Buyer_details')
            .select('*')
            .eq("customer_id", trip_Details[0].customer_id)
          if (buyer_details !== null && buyer_details.length > 0) {

            let { data: supplier_details, supplier_error } = await supabase
              .from('supplier_details')
              .select('*')
              .eq("man_id", trip_Details[0].man_id)
            if (supplier_details !== null && supplier_details.length > 0) {
              let vehicle_invoice_date = new Date().toLocaleDateString()


              let { data: vehicle_invoice, vehicle_invoice_error } = await supabase
                .from('vehicle_invoice_details')
                .insert([
                  {
                    vehicle_invoice_id: vehicle_invoice_id, vehicle_invoice_date: vehicle_invoice_date, driver_id: driver_details[0].driver_id, driver_license_no: driver_details[0].driver_licence, driver_name: driver_details[0].driver_name, driver_contact_no: driver_details[0].driver_phone, vehicle_id: vehicledetail[0].vehicle_id, vehicle_no: vehicledetail[0].vehicle_number, vehicle_type: vehicledetail[0].vehicle_type, vehicle_owner_no: vehicledetail[0].vehicle_owner_number, man_name: supplier_details[0].man_name, man_address: supplier_details[0].man_address, man_id: supplier_details[0].man_id, man_gstnumber: supplier_details[0].man_gstnumber, customer_id: buyer_details[0].customer_id, customer_name: buyer_details[0].customer_name, customer_address: buyer_details[0].customer_address, customer_gst: buyer_details[0].customer_gstnumber, trip_id: trip_Details[0].trip_id, transport_charges: trip_Details[0].transport_charges, transport_distance: trip_Details[0].transport_distance, trip_amount: trip_Details[0].trip_amount, payment_status: trip_Details[0].payment_status, payment_type: trip_Details[0].payment_by, created_by: window.localStorage.getItem("useremail"), pick_up: trip_Details[0].pick_up, drop_off: trip_Details[0].drop_off
                  }])
              if (vehicle_invoice !== null && vehicle_invoice.length > 0) {

                toast.success("Status Updated")
                getTripDetail()

              } else {
                if (vehicle_invoice_error !== null) { }
                await supabase
                  .from('trip_details')
                  .update({ vehicle_status: "" })
                  .eq("trip_id", tripid)
                toast.error("Status Not Updated")
                getTripDetail()
              }


            } else {
              if (supplier_error !== null) { }
              await supabase
                .from('trip_details')
                .update({ vehicle_status: "" })
                .eq("trip_id", tripid)
              toast.error("Status Not Updated")
              getTripDetail()
            }


          } else {
            if (buyer_error !== null) { }
            await supabase
              .from('trip_details')
              .update({ vehicle_status: "" })
              .eq("trip_id", tripid)
            toast.error("Status Not Updated")
            getTripDetail()
          }
        } else {
          if (vehicle_error !== null) { }
          await supabase
            .from('trip_details')
            .update({ vehicle_status: "" })
            .eq("trip_id", tripid)
          toast.error("Status Not Updated")
          getTripDetail()
        }

      } else {
        if (driver_error !== null) { }
        await supabase
          .from('trip_details')
          .update({ vehicle_status: "" })
          .eq("trip_id", tripid)
        toast.error("Status Not Updated")
        getTripDetail()
      }

    } else {
      if (error !== null) { }
      toast.error("Status Not Updated")
    }

  }
  const updatedtripdistance = async (tripid) => {
    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .update({ vehicle_status: "", driver_status: "", transport_charges: parseInt(transport_distance) * 45, transport_distance: parseInt(transport_distance), pick_up: pick_up, drop_off: drop_off })
      .eq("trip_id", tripid)
    if (trip_Details !== null && trip_Details.length > 0) {

      toast.success(" Transport Distance Updated")
      setLarge(!Large);
      getTripDetail()
    } else {
      if (error !== null) { }
      toast.error("Transport Distance Not Updated")
    }

  }
  function Updatedetail(id) {
    if (trip_status === 0) {
      const data = trip_detail.filter((item) => item.trip_id === id)
      seteditid(id)
      settransport_charges(data[0].transport_charges)
      settransport_distance(data[0].transport_distance)
      setpick_up(data[0].pick_up)
      setdrop_off(data[0].drop_off)

      setLarge(!Large)
    } else {
      const data = completed_trip_detail.filter((item) => item.trip_id === id)
      seteditid(id)
      settransport_charges(data[0].transport_charges)
      settransport_distance(data[0].transport_distance)
      setpick_up(data[0].pick_up)
      setdrop_off(data[0].drop_off)

      setLarge(!Large)
    }

  }
  const handlePdf = () => {
    const downloadSection = document.getElementById('trip_table');




    html2canvas(downloadSection).then(function (
      canvas
    ) {
      var cWidth = canvas.width;
      var cHeight = canvas.height;
      var topLeftMargin = 0;
      var pdfWidth = cWidth + topLeftMargin * 2;
      var pdfHeight = pdfWidth * 1.5 + topLeftMargin * 2;
      var canvasImageWidth = cWidth;
      var canvasImageHeight = cHeight;
      var totalPDFPages = Math.ceil(cHeight / pdfHeight) - 1;
      canvas.getContext('2d');
      var imgData = canvas.toDataURL('image/png', 1.0);
      var pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
      pdf.addImage(
        imgData,
        'PNG',
        topLeftMargin,
        topLeftMargin,
        canvasImageWidth,
        canvasImageHeight
      );
      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(pdfWidth, pdfHeight);
        pdf.addImage(
          imgData,
          'PNG',
          topLeftMargin,
          -(pdfHeight * i) + topLeftMargin * 0,
          canvasImageWidth,
          canvasImageHeight
        );
      }
      pdf.save('TripDriver_details.pdf');
    });
  }
  const closeCustomizer = () => {
    setRightSidebar(!rightSidebar)
    document.querySelector(".customizer-contain").classList.remove('open');

  }



  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Trip Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12" id="maintrip" style={window.innerWidth < 800 ? { paddingLeft: '5px', paddingRight: "5px" } : { width: "100%" }}>
            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                Update Here For Trip
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Transport Distance<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="10">
                        <Input className="form-control" type="number" placeholder="Enter Transport Distance" value={transport_distance} onChange={(e) => { settransport_distance(e.target.value); settransport_charges(parseInt(e.target.value) * 45) }} />
                      </Col>
                      <Col sm="2">
                        <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{"Km"}</span>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Transport Charges<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Transport Charges" value={transport_charges} onChange={(e) => { settransport_charges(e.target.value) }} />
                      </Col>
                    </FormGroup>

                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Pick Up Time<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="datetime-local" placeholder="Enter Paid At" value={pick_up} onChange={(e) => { setpick_up(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Drop Off Time<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="datetime-local" placeholder="Enter Paid At" value={drop_off} onChange={(e) => { setdrop_off(e.target.value) }} />
                      </Col>
                    </FormGroup>

                    <FormGroup className="mb-0 mt-3">


                      <Button color="primary" className="btn-block" onClick={() => {
                        updatedtripdistance(editid)
                      }}>PROCEED </Button>
                    </FormGroup>




                  </Col>
                </Row>
              </ModalBody>
            </Modal>
            <div className="customizer-contain">
              <div className="tab-content" id="c-pills-tabContent">
                <div className="customizer-header">
                  <i className="icon-close" onClick={closeCustomizer}></i>
                  <h5>{t("filter")}</h5>



                </div>
                <div className="customizer-body custom-scrollbar">
                  <TabContent activeTab={activeTab1}>
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12" style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                          <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer", backgroundColor: "#e8e8e8", padding: "5px 10px", borderRadius: "20px" }} onClick={() => {
                            getTripDetail();
                          }}>{t("Clear")}</div>

                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="exampledate">{t("Trip Date")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                          </div>
                        </Col>




                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Delivery Status")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                              <option value={""}>{t("Delivery")} </option>
                              <option value={"Delivered"}>{t("Delivered")}</option>
                              <option value={"IN-TRANSIT"}>{t("IN-TRANSIT")}</option>

                            </Input></div>
                        </Col>

                        <Col sm="12" style={{ display: "flex", justifyContent: "center", margin: "10px" }}>

                          <div style={{ textAlign: "center" }}>
                            <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "5px" }} onClick={() => { closeCustomizer(); trip_detail.length > 0 ? settrip_status(0) : settrip_status(1) }}>{t("Show Result")} {tabdelivery !== "" || tabtripdate !== "" ? parseInt(trip_detail.length) + parseInt(completed_trip_detail.length) : ""}</button>
                          </div>


                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
            {window.innerWidth < 800 ? <>
              <Table className='table-borderless'>
                <tbody>
                  <tr style={{ display: "flex", alignItems: "center" }}>
                    {trip_type.length > 0 && trip_type.map((item, index) => {
                      return (
                        <td style={{ verticalAlign: "inherit" }} key={index}>
                          <button className="btn " style={{ backgroundColor: index === trip_status ? "#211833" : "#e8e8e8", color: index !== trip_status ? "black" : "white", borderRadius: "20px", fontSize: "14px", padding: "9px 12px" }} onClick={() => { getTripDetail(); settrip_status(index) }}>{item.trip_name}</button>
                        </td>
                      )
                    })}
                    <td>
                      <div onClick={() => { openCustomizer('1') }} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        <Icon icon="bx:filter" color="black" width="35" height="35" />
                      </div>
                    </td>


                  </tr>
                </tbody>
              </Table>
              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">
                    {trip_status === 0 ? <>
                      {trip_detail.length > 0 ? <>
                        {trip_detail.map((data, i) => {
                          return (
                            <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                              <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                                <h5 className="mb-0" style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                    <div className="email-app-sidebar left-bookmark">
                                      <div className="media" style={{ alignItems: "center " }}>
                                        <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px 15px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div>
                                        </div>
                                        <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Trip To</span>
                                          <span style={{ display: "block" }}>{data.customer_name}</span>
                                          <span style={{ display: "block" }}>{data.customer_address}</span>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>From</span>
                                          <span style={{ display: "block" }}>{data.man_name}</span>
                                          <span style={{ display: "block" }}>{data.man_address}</span>
                                        </div>


                                      </div>
                                    </div>



                                  </Accordion.Toggle>
                                  <div className="media-size-email" style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    Updatedetail(data.trip_id)
                                  }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>


                                  </div>
                                </h5>
                              </CardHeader>
                              <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                                <CardBody>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>

                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle</span>
                                        <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                        <span style={{ display: "block" }}>{data.inventory_type}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                        <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                        <span style={{ display: "block" }}>{data.payment_status}</span>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Driver</span>
                                        <span style={{ display: "block" }}>{data.driver_name}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                        <span style={{ display: "block" }}>{data.inventory_quantity}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Charges</span>
                                        <span style={{ display: "block" }}>&#8377; &nbsp;{data.transport_charges}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Delivered</span>

                                        <span style={{ display: "block" }}>{data.delivery_status}</span>
                                      </div>


                                    </div>
                                    <br />
                                    <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {parseInt(data.trip_amount) + ((parseInt(data.trip_amount) * 18) / 100) + parseInt(data.transport_charges) + ((parseInt(data.transport_charges) * 5) / 100)}</span></p>
                                    {data.vehicle_status !== "true" && data.vehicle_status !== "false" ? <><button className='btn btn-success m-1' style={{ borderRadius: "10px" }} onClick={() => {
                                      updatestatus(data.trip_id, data.vehicle_invoice_id, true)
                                    }}>Accept</button> &nbsp;<button className='btn btn-danger m-1' style={{ borderRadius: "10px" }} onClick={() => {
                                      updatestatus(data.trip_id, data.vehicle_invoice_id, false)
                                    }}>Reject</button></> : <>{data.vehicle_status === "true" ? <span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{"Accepted"}</span> : <span style={{ color: "#E50014", textTransform: "uppercase", fontWeight: "500" }}>{"Rejected"}</span>}</>}
                                    {data.driver_coordinates !== null && data.driver_coordinates !== "" && data.Buyer_coordinate === null || data.Buyer_coordinate === "" ?

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div> : ""}
                                    {data.Buyer_coordinate !== null && data.Buyer_coordinate !== "" && data.driver_coordinates !== null && data.driver_coordinates !== "" ?

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            {
                                              location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                              option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            }
                                          ]
                                          }















                                        />
                                      </div> :

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps

                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            // {
                                            //     location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            //     option: { title: data.driver_name, subTitle: "Driver" },


                                            // },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div>
                                    }
                                  </div>


                                </CardBody>
                              </Accordion.Collapse>
                            </Card>
                          )


                        })}</> : <Card>
                        <CardHeader >
                          <h5 className="mb-0">
                            <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                              No Record Found
                            </Accordion.Toggle>
                          </h5>
                        </CardHeader>
                      </Card>}</> : <>{completed_trip_detail.length > 0 ? <>
                        {completed_trip_detail.map((data, i) => {
                          return (
                            <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                              <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                                <h5 className="mb-0" style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                    <div className="email-app-sidebar left-bookmark">
                                      <div className="media" style={{ alignItems: "center " }}>
                                        <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px 15px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div>
                                        </div>
                                        <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Trip To</span>
                                          <span style={{ display: "block" }}>{data.customer_name}</span>
                                          <span style={{ display: "block" }}>{data.customer_address}</span>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>From</span>
                                          <span style={{ display: "block" }}>{data.man_name}</span>
                                          <span style={{ display: "block" }}>{data.man_address}</span>
                                        </div>


                                      </div>
                                    </div>



                                  </Accordion.Toggle>
                                  <div className="media-size-email" style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    Updatedetail(data.trip_id)
                                  }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>



                                  </div>
                                </h5>
                              </CardHeader>
                              <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                                <CardBody>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>

                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle</span>
                                        <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                        <span style={{ display: "block" }}>{data.inventory_type}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                        <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                        <span style={{ display: "block" }}>{data.payment_status}</span>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Driver</span>
                                        <span style={{ display: "block" }}>{data.driver_name}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                        <span style={{ display: "block" }}>{data.inventory_quantity}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Charges</span>
                                        <span style={{ display: "block" }}>&#8377; &nbsp;{data.transport_charges}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Delivered</span>

                                        <span style={{ display: "block" }}>{data.delivery_status}</span>
                                      </div>


                                    </div>
                                    <br />
                                    <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {parseInt(data.trip_amount) + ((parseInt(data.trip_amount) * 18) / 100) + parseInt(data.transport_charges) + ((parseInt(data.transport_charges) * 5) / 100)}</span></p>
                                    {data.vehicle_status !== "true" && data.vehicle_status !== "false" ? <><button className='btn btn-success m-1' style={{ borderRadius: "10px" }} onClick={() => {
                                      updatestatus(data.trip_id, data.vehicle_invoice_id, true)
                                    }}>Accept</button> &nbsp;<button className='btn btn-danger m-1' style={{ borderRadius: "10px" }} onClick={() => {
                                      updatestatus(data.trip_id, data.vehicle_invoice_id, false)
                                    }}>Reject</button></> : <>{data.vehicle_status === "true" ? <span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{"Accepted"}</span> : <span style={{ color: "#E50014", textTransform: "uppercase", fontWeight: "500" }}>{"Rejected"}</span>}</>}
                                    {data.driver_coordinates !== null && data.driver_coordinates !== "" && data.Buyer_coordinate === null || data.Buyer_coordinate === "" ?

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div> : ""}
                                    {data.Buyer_coordinate !== null && data.Buyer_coordinate !== "" && data.driver_coordinates !== null && data.driver_coordinates !== "" ?

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            {
                                              location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                              option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            }
                                          ]
                                          }















                                        />
                                      </div> :

                                      <div className='map-six' key={i} >
                                        <ReactBingmaps

                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            // {
                                            //     location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            //     option: { title: data.driver_name, subTitle: "Driver" },


                                            // },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div>
                                    }
                                  </div>


                                </CardBody>
                              </Accordion.Collapse>
                            </Card>
                          )


                        })}</> : <Card>
                        <CardHeader >
                          <h5 className="mb-0">
                            <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                              No Record Found
                            </Accordion.Toggle>
                          </h5>
                        </CardHeader>
                      </Card>}</>}
                  </div>

                </Accordion>
              </div>
            </> :
              <Card>





                <CardBody>
                  <div className="table-responsive ">
                    <Table className='table-borderless'>
                      <tbody>
                        <tr style={{ display: "flex", alignItems: "center" }}>
                          <td style={{ verticalAlign: "inherit" }}>
                            <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer" }} onClick={() => {
                              getTripDetail()
                            }}>All</div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                            </div>
                          </td>




                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                                <option value={""}>Delivery </option>
                                <option value={"Delivered"}>Delivered</option>
                                <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                              </Input></div>
                          </td>

                          <td>
                            <div style={{ textAlign: "center" }}>
                              <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "7px" }} onClick={() => { handlePdf() }}>Download PDF</button>
                            </div>
                          </td>



                        </tr>
                      </tbody>
                    </Table>
                    <Table className='table-borderless'>
                      <tbody>
                        <tr style={{ display: "flex", alignItems: "center" }}>
                          {trip_type.length > 0 && trip_type.map((item, index) => {
                            return (
                              <td style={{ verticalAlign: "inherit" }} key={index}>
                                <button className="btn " style={{ backgroundColor: index === trip_status ? "#24a0ed" : "whitesmoke", color: index !== trip_status ? "black" : "white", borderRadius: "7px" }} onClick={() => { getTripDetail(); settrip_status(index) }}>{item.trip_name}</button>
                              </td>
                            )
                          })}


                        </tr>
                      </tbody>
                    </Table>


                    <Table id='trip_table' >
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Date"}</th>
                          <th scope="col">{"Vehicle"}</th>
                          <th scope="col">{"Driver"}</th>
                          <th scope="col">{"Quantity"}</th>
                          <th scope="col">{"Inventory"}</th>

                          <th scope="col">{"Buyer"}</th>


                          <th scope="col">{"Transport distance"}</th>
                          <th scope='col'>{"Transport Cost"}</th>
                          <th scope='col'>{"Total Cost"}</th>
                          <th scope="col">{"Delivery"}</th>
                          <th scope="col">{"Vehicle Status"}</th>
                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trip_status === 0 ? <>
                          {trip_detail.length > 0 ? <>
                            {trip_detail.map((data, i) => {
                              return (
                                <tr key={i} style={{ textAlign: "center" }}>
                                  <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div></td>
                                  <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "700", fontSize: "19px" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                                  <td>{data.driver_name}</td>
                                  <td>{data.inventory_quantity}</td>
                                  <td>{data.inventory_type}</td>
                                  <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span></td>


                                  <td>{data.transport_distance + " Km"}</td>
                                  <td>{data.transport_charges}</td>
                                  <td>{(parseInt(data.trip_amount) + parseInt(data.transport_charges)) + ((parseInt(data.trip_amount) * 18) / 100)}</td>
                                  <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td>


                                  <td>{data.vehicle_status !== "true" && data.vehicle_status !== "false" ? <><button className='btn btn-success' onClick={() => {
                                    updatestatus(data.trip_id, data.vehicle_invoice_id, true)
                                  }}>Accept</button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                    updatestatus(data.trip_id, data.vehicle_invoice_id, false)
                                  }}>Reject</button></> : <>{data.vehicle_status === "true" ? <span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{"Accepted"}</span> : <span style={{ color: "#E50014", textTransform: "uppercase", fontWeight: "500" }}>{"Rejected"}</span>}</>}</td>
                                  <td><button className='btn btn-warning' onClick={() => {
                                    Updatedetail(data.trip_id)
                                  }}><i className='fa fa-edit'></i></button></td>
                                </tr>
                              )
                            })}
                          </>
                            : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}</> : <>
                          {completed_trip_detail.length > 0 ? <>
                            {completed_trip_detail.map((data, i) => {
                              return (
                                <tr key={i} style={{ textAlign: "center" }}>
                                  <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div></td>
                                  <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "700", fontSize: "19px" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                                  <td>{data.driver_name}</td>
                                  <td>{data.inventory_quantity}</td>
                                  <td>{data.inventory_type}</td>
                                  <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span></td>


                                  <td>{data.transport_distance + " Km"}</td>
                                  <td>{data.transport_charges}</td>
                                  <td>{(parseInt(data.trip_amount) + parseInt(data.transport_charges)) + ((parseInt(data.trip_amount) * 18) / 100)}</td>
                                  <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td>


                                  <td>{data.vehicle_status !== "true" && data.vehicle_status !== "false" ? <><button className='btn btn-success' onClick={() => {
                                    updatestatus(data.trip_id, data.vehicle_invoice_id, true)
                                  }}>Accept</button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                    updatestatus(data.trip_id, data.vehicle_invoice_id, false)
                                  }}>Reject</button></> : <>{data.vehicle_status === "true" ? <span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{"Accepted"}</span> : <span style={{ color: "#E50014", textTransform: "uppercase", fontWeight: "500" }}>{"Rejected"}</span>}</>}</td>
                                  <td><button className='btn btn-warning' onClick={() => {
                                    Updatedetail(data.trip_id)
                                  }}><i className='fa fa-edit'></i></button></td>
                                </tr>
                              )
                            })}
                          </>
                            : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}</>}

                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default TripVehicle;